export default function sectionTile({ children }) {
  return (
    <div className="relative">
      <h2 className="pl-6 text-yellow font-serif text-6xl font-medium md:pl-0 md:text-7xl">{children}</h2>
      <div className="absolute -top-2 left-1 w-0 h-14 border-r-2 border-yellow transform rotate-12 md:-left-8 md:h-20"></div>
    </div>
  )
}
